import React from 'react';
import PageSelector from '../PageSelector/PageSelector';
import './MerchantDocuments.scss';
import counterpart from 'counterpart';

const MerchantDocuments = (props) => {
  return (
    <>
        {props.merchantDocs.map(doc => {
            return (
            <div className='merchant-documents'>
                <div className='merchant-documents__header'>
                    <div className='merchant-documents__header--file'>{counterpart('globalTranslate.takeAction.file')}</div>
                    <div className='merchant-documents__header--desc'>{counterpart('globalTranslate.takeAction.description')}</div>
                    <div className='merchant-documents__header--src'>{counterpart('globalTranslate.takeAction.source')}</div>
                </div>
                <div className='merchant-documents__details'>
                    <div className='merchant-documents__details--file'>{doc.file.name}</div>
                    <div className='merchant-documents__details--desc'>Merchant</div>
                    <div className='merchant-documents__details--src'>Disputes Management</div>
                </div>
                <PageSelector
                pageList={doc.response?.data?.base64}
                imageCheckBoxRequired={false}
                selectAllButtonRequired={false}
                />
            </div>
            )
        })}
    </>
  );
};

export default MerchantDocuments;
